import { accessService } from '@shared/api';

import type { TenantPermission } from '../model/types';

// така сама структура як в тенанта
export type GetPermissionsResponse = TenantPermission[];

export const getPermissions = () =>
  accessService
    .get<GetPermissionsResponse>('/client/permissions')
    .then((response) => response.data);
